// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="dialogHeader" id="dialogHeader">Payment Details {{data.paymentHistory.date.formattedFullDate}}</h1>
        </div>
        <div class="hoa-dialog__main">
            <div class="HOA-propertyblock-flextable">
                <!-- PSEUDO ROW HEADER -->
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--30 HOA-propertyblock-flextable--truncate">
                    <div class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
                         tid="dateLabel">Date
                    </div>
                </div>
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--30 HOA-propertyblock-flextable--truncate">
                    <div class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
                         tid="amountLabel">Amount
                    </div>
                </div>

                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--30 HOA-propertyblock-flextable--truncate">
                    <div class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
                         tid="statusLabel">Status
                    </div>
                </div>
                <!-- PSEUDO ROW -->
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--30 HOA-propertyblock-flextable--truncate">
                    <div class="HOA-propertyblock-flextable__cell-value HOA-propertyblock-flextable--truncate"
                         tid="dateValue">{{data.paymentHistory.date.formattedFullDate}}</div>
                </div>
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--30 HOA-propertyblock-flextable--truncate">
                    <div class="HOA-propertyblock-flextable__cell-value HOA-propertyblock-flextable--truncate"
                         tid="amountValue">{{data.paymentHistory.amount | currency:"\$"}}</div>
                </div>

                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--30 HOA-propertyblock-flextable--truncate">
                    <div class="HOA-propertyblock-flextable__cell-value payment-history-status-label"
                         tid="statusValue">{{data.paymentHistory.status | formatStatus}}</div>
                </div>
                <!-- PSEUDO ROW HEADER -->
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--50 HOA-propertyblock-flextable--truncate">
                    <div class="u-mT8 HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
                         tid="nicknameLabel">Payment Method
                    </div>
                </div>
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--50 HOA-propertyblock-flextable--truncate">
                    <div class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
                         *ngIf="data.paymentHistory.paymentMethodCode === 'card' && data.paymentHistory.paymentMethodId != null"
                         tid="expDateLabel">Exp. Date
                    </div>
                </div>
                <div class="hide HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--30 HOA-propertyblock-flextable--truncate">
                    <div class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
                         tid="channelLabel">Channel
                    </div>
                </div>
                <!-- PSEUDO ROW -->
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--50">
                    <div class="HOA-propertyblock-flextable__cell-value">
                                <span class="HOA-font-capitalize"
                                      tid="typeValue">{{data.paymentHistory.paymentMethodCode}}</span>
                        <span *ngIf="data.paymentHistory.paymentMethod" tid="nicknameValue"> - {{data.paymentHistory.paymentMethod.nickname || data.paymentHistory.paymentMethodNickname}}</span>
                        <span *ngIf="data.paymentHistory.paymentMethod" tid="maskedNumberValue">({{data.paymentHistory.paymentMethod.maskedId || data.paymentHistory.maskedId}})</span>
                    </div>
                </div>
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--50 HOA-propertyblock-flextable--truncate">
                    <div class="HOA-propertyblock-flextable__cell-value HOA-propertyblock-flextable--truncate"
                         *ngIf="data.paymentHistory.paymentMethod && data.paymentHistory.paymentMethod.expirationMonth"
                         tid="expDateValue">{{data.paymentHistory.paymentMethod.expirationMonth}}/{{data.paymentHistory.paymentMethod.expirationYear}}</div>
                </div>
                <div class="hide HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--30 HOA-propertyblock-flextable--truncate">
                    <div class="HOA-propertyblock-flextable__cell-value HOA-propertyblock-flextable--truncate"
                         tid="channelValue"><!-- Channel type-->
                    </div>
                </div>
                <!-- PSEUDO ROW HEADER -->
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--100 HOA-propertyblock-flextable--truncate">
                    <div class="u-mT8 HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
                         *ngIf="data.paymentHistory.scheduleFrequency || data.paymentHistory.paymentTiming"
                         tid="timingFreqLabel">Type
                    </div>
                </div>
                <!-- PSEUDO ROW -->
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--100">
                    <div class="HOA-propertyblock-flextable__cell-value HOA-font-capitalize"
                         *ngIf="data.paymentHistory.scheduleFrequency || data.paymentHistory.paymentTiming"
                         tid="timingFreqValue">{{data.paymentHistory.scheduleFrequency}} {{data.paymentHistory.paymentTiming}}</div>
                </div>
                <!-- PSEUDO ROW HEADER -->
                <div *ngIf="data.paymentHistory.details.length > 0"
                     class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--50 HOA-propertyblock-flextable--truncate">
                    <div class="u-mT8 HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
                         tid="detailDescriptionLabel">Item Detail
                    </div>
                </div>
                <div *ngIf="data.paymentHistory.details.length > 0"
                     class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--25 HOA-propertyblock-flextable--truncate">
                    <div class="u-mT8 HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
                         tid="detailQuantityLabel">Quantity
                    </div>
                </div>
                <div *ngIf="data.paymentHistory.details.length > 0"
                     class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--25 HOA-propertyblock-flextable--truncate">
                    <div class="u-mT8 HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate"
                         tid="detailAmountLabel">Item Amount
                    </div>
                </div>
                <!-- PSEUDO ROW -->
                <ng-container *ngFor="let detail of data.paymentHistory.details">
                    <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--50">
                        <div class="HOA-propertyblock-flextable__cell-value HOA-font-capitalize"
                             tid="detailDescriptionValue">{{detail.description}}</div>
                    </div>
                    <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--25">
                        <div class="HOA-propertyblock-flextable__cell-value HOA-font-capitalize"
                             tid="detailQuantityValue">{{detail.qty}}</div>
                    </div>
                    <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--25">
                        <div class="HOA-propertyblock-flextable__cell-value HOA-font-capitalize"
                             tid="detailAmountValue">{{detail.amount | currency}}</div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="okButton" id="okButton" class="Button Button--blue Button--minWidth130"
                    (click)="closeDialog('OK')">Close
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;